import { logger } from "./utils/logger";

// rails側にもページタイトルがあるので変更漏れに注意
const BASE_MAP_TITLE = "電源マップ - モバイラーズオアシス";

const buildMapPageTitle = (query) => {
  if (!query) return BASE_MAP_TITLE;

  return `${query}の${BASE_MAP_TITLE}`;
};

export function setupSearchPanel({
  map,
  elements,
  fetchImpl = fetch,
  origin = window.location.origin,
  historyObj = window.history,
  locationObj = window.location,
  documentObj = document
}) {
  const openSearchPanel = () => {
    elements.panel?.classList.remove("hidden");
    elements.input?.focus();
  };

  const closeSearchPanel = () => {
    const activeElement = document.activeElement;
    const shouldRestoreFocus = !!(elements.panel && activeElement instanceof Node && elements.panel.contains(activeElement));

    elements.panel?.classList.add("hidden");
    if (elements.error) elements.error.classList.add("hidden");
    if (elements.input) {
      elements.input.value = "";
      elements.input.blur();
    }
    if (shouldRestoreFocus) elements.openButton?.focus();
  };

  const performSearch = async () => {
    const query = elements.input?.value?.trim();
    if (!query) return;

    if (elements.error) elements.error.classList.add("hidden");
    if (elements.submit) elements.submit.disabled = true;

    try {
      const url = new URL("/api/v2/geocoding", origin);
      url.searchParams.set("q", query);

      const res = await fetchImpl(url.toString(), { headers: { Accept: "application/json" } });
      const data = await res.json();

      if (res.ok && data.status === "OK") {
        const nextUrl = new URL(locationObj.href);
        nextUrl.pathname = `/map/${encodeURIComponent(query)}`;
        historyObj.replaceState({}, "", nextUrl);
        documentObj.title = buildMapPageTitle(query);
        map.flyTo({ center: [data.lng, data.lat], zoom: 16, essential: true });
        closeSearchPanel();
      } else if (elements.error) {
        elements.error.classList.remove("hidden");
      }
    } catch (error) {
      logger.error(error);
      if (elements.error) elements.error.classList.remove("hidden");
    } finally {
      if (elements.submit) elements.submit.disabled = false;
    }
  };

  elements.openButton?.addEventListener("click", openSearchPanel);
  elements.closeButton?.addEventListener("click", closeSearchPanel);
  elements.submit?.addEventListener("click", performSearch);
  elements.input?.addEventListener("keydown", (event) => {
    if (event.key === "Enter") performSearch();
  });

  return {
    openSearchPanel,
    closeSearchPanel,
    performSearch
  };
}
